<template>
    <div class="bbyklist">
        <el-card>
            <main>
                <h4 style="color:#F56C6C;font-size:14px;margin-bottom:10px">{{ org }}</h4>
                <span style="font-size:12px">类型：  </span>
                <el-select v-model="zfk" style="width: 180px;"  @change="getYk()" >
                    <el-option label="主卡" value="主卡"></el-option>
                    <el-option label="副卡" value="副卡"></el-option>
                    <el-option label="主副卡" value="主副卡"> </el-option>
                </el-select>
            </main>

            <br/>
            
            <el-table
                algin=center
                stripe
                size='mini'
                :cell-style="{fontSize:'12px',borderColor:'black'}" 
                :header-cell-style="{fontSize:'12px',background:'#F5F7FA',borderColor:'black'}"
                border
                :data="list"
                @row-click="(row,column,e)=>go(row)">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>

                <el-table-column 
                    prop="num"
                    width="160"
                    label="卡号" >
                </el-table-column>

                <el-table-column 
                    prop="chepai"
                    width="90"
                    label="车牌" >
                </el-table-column>

                <el-table-column 
                    :render-header="renderHeader1"
                    prop="money"
                    label="余额">
                </el-table-column>

            </el-table>
        </el-card>
    </div>
</template>

<script>
import { ykList,ykList2 } from '../router/api';

export default {
    data() {
        return {
            list: [],
            list2:'',
            org:'',
            temp: true,
            zfk:'副卡'
        }; 
    },
  
    async mounted() {
        this.org = this.$route.query.org
        await this.getMyy()
    },
    methods: {
        renderHeader1() {
            return (
                <div>
                    <span onClick={this.pai1}>余额</span>
                </div>
            )
        },
        
        pai1() {
            this.temp = !this.temp;
            var flag = this.list.pop()
            if (this.temp) {
                this.list.sort(function (x, y) {
                    return y.money - x.money;
                });
            } else {
                this.list.sort(function (x, y) {
                    return x.money - y.money;
                });
            }                 
            this.list.push(flag);
        },
        getYk() {
            if(this.zfk=='主卡') {
                this.getZhu()
            } else {
                this.getMyy()
            }
        },

        getZhu() {
            this.list = []
            ykList2({
                id:'',
                org:this.org,
            }).then(res=> {
                if(res.code==1) {
                    this.list = res.data
                    this.list2 = res.data2
                    this.list.push({
                        num:'合计',
                        chepai:'',
                        money:this.list2
                    })
                }
            }).catch(err=> {
                console.log(err);
            });
        },

        async getMyy() {
            this.list = []
            await ykList({
                id:'',
                org:this.org,
                chepai:'',
                zfk:this.zfk,
            }).then(res=> {
                if(res.code==1) {
                    this.list = res.data
                    this.list2 = res.data2
                    this.list.push({
                        num:'合计',
                        chepai:'',
                        money:this.list2
                    })
                }
            }).catch(err=> {
                console.log(err);
            });
        },

        go(row) {
            this.$router.push(`/bbyklist2?org=${this.org}&num=${row.num}&type=${this.zfk}`);
        },
       
    },
};
</script>
<style lang="less" scoped>
.bbyklist .el-table {
    border: solid 1px black
}
</style>


